// extracted by mini-css-extract-plugin
export default {"container":"ym-z","title":"zm-z","linkContainer":"Am-z","viewItemLink":"Bm-z"};